<template>
  <div class="income-container">
    <van-nav-bar 
      :title="this.groupInfo ? (this.groupInfo.type === 0 ? '收益流水' : '充值流水(撩币)') : ''" 
      left-text="" 
      left-arrow
      @click-left="onClickLeft" 
      @click-right="onClickRight" 
      :style="{ backgroundColor: '#FFD700', color: '#333333' }"
      :title-style="{ color: '#333333' }"
      :left-arrow-style="{ color: '#333333' }"
    />
    <div v-if="!!groupInfo" class="content-wrapper">
      <van-search class="search-bar" v-model="search" @search="onSearch" shape="round" show-action placeholder="输入用户ID">
        <template #action>
          <div class="search-btn" @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="filter-section">
        <div class="id-type-group">
          <van-radio-group v-model="checked" direction="horizontal">
            <van-radio name="0" icon-size="14px">用户ID</van-radio>
            <van-radio name="1" icon-size="14px">上级ID</van-radio>
          </van-radio-group>
        </div>
        <van-dropdown-menu v-if="this.groupInfo && this.groupInfo.type === 0" class="income-type-select"
          active-color="#ff9500">
          <van-dropdown-item v-model="incomeType" :options="incomeTypes" @change="onIncomeTypeChanged" />
        </van-dropdown-menu>
      </div>
      <div class="date-range-selector">
        <div class="date-btn ltime" @click="onTimeBeginTapped">{{ timeBeginDisplay }}</div>
        <span class="date-separator">至</span>
        <div class="date-btn" @click="onTimeEndTapped">{{ timeEndDisplay }}</div>
      </div>
      
      <van-list class="transaction-list" v-model:loading="loading" :immediate-check="false" :finished="finished"
        finished-text="没有更多了" @load="onLoad">
        <div class="transaction-card" v-for="(li, i) in list" :key="i">
          <div class="transaction-header">
            <div class="user-info">
              <div class="user-name">{{ li.userInfo.nickName }} </div>
              <div class="user-id">ID: {{ li.userId }}</div>
            </div>
            <div class="amount">{{ li.num }} </div>
          </div>
          <div class="transaction-footer">
            <div class="transaction-time">{{ getDisplayTime(li.time) }}</div>
            <div class="transaction-desc">{{ li.transactionName }}</div>
          </div>
        </div>
      </van-list>
      
      <van-popup v-model:show="showDatePicker" position="bottom" round>
        <van-datetime-picker v-model="datePicker" type="date" title="选择日期" :min-date="minDate" :max-date="maxDate"
          @confirm="onDatePickerConfirm" @cancel="onDatePickerCancel" />
      </van-popup>
    </div>
    
    <div v-if="!!groupInfo" class="summary-section">
     <div v-if="incomeList && incomeList.length === 0" class="empty-state">
      <van-icon name="document-text" size="48" color="#c9c9c9" />
      <span>暂无相关流水数据</span>
    </div>
    
    <!-- 统计数据卡片 -->
    <div v-else class="statistics-table-container">
      <table class="statistics-table">
        <thead>
          <tr>
            <th>流水类型</th>
            <th v-if="isColumnNotEmpty('totalIncome')">总流水</th>
            <th v-if="isColumnNotEmpty('totalParentIncome')">邀请分成</th>
            <th v-if="isColumnNotEmpty('totalOwnerIncome')">组长分成</th>
          </tr>
        </thead>
        <tbody>
          <!-- 收益流水 - type=0 -->
          <tr v-if="isDiaplay(getIncomeByType(0))" class="income-row">
            <td class="row-label">收益流水</td>
            <td v-if="isColumnNotEmpty('totalIncome')" class="primary-value">{{ formatNumber(getIncomeByType(0).totalIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalParentIncome')">{{ formatNumber(getIncomeByType(0).totalParentIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalOwnerIncome')">{{ formatNumber(getIncomeByType(0).totalOwnerIncome) }}</td>
          </tr>
          
          <!-- 充值流水 - type=1 -->
          <tr v-if="isDiaplay(getIncomeByType(1))" class="recharge-row">
            <td class="row-label">充值流水</td>
            <td v-if="isColumnNotEmpty('totalIncome')" class="primary-value">{{ formatNumber(getIncomeByType(1).totalIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalParentIncome')">{{ formatNumber(getIncomeByType(1).totalParentIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalOwnerIncome')">{{ formatNumber(getIncomeByType(1).totalOwnerIncome) }}</td>
          </tr>
          
          <!-- 会员流水 - type=2 -->
          <tr v-if="isDiaplay(getIncomeByType(2))" class="member-row">
            <td class="row-label">会员流水</td>
            <td v-if="isColumnNotEmpty('totalIncome')" class="primary-value">{{ formatNumber(getIncomeByType(2).totalIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalParentIncome')">{{ formatNumber(getIncomeByType(2).totalParentIncome) }}</td>
            <td v-if="isColumnNotEmpty('totalOwnerIncome')">{{ formatNumber(getIncomeByType(2).totalOwnerIncome) }}</td>
          </tr>

          <!-- 总计行 -->
          <tr class="total-row">
            <td class="row-label">总计</td>
            <td v-if="isColumnNotEmpty('totalIncome')" class="highlight-value">{{ formatNumber(calculateGrandTotal()) }}</td>
            <td v-if="isColumnNotEmpty('totalParentIncome')" class="highlight-value">{{ formatNumber(calculateTotalParentIncome()) }}</td>
            <td v-if="isColumnNotEmpty('totalOwnerIncome')" class="highlight-value">{{ formatNumber(calculateTotalOwnerIncome()) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import { Toast } from "vant"
import moment from 'moment'


export default {
  name: 'Income',
  data() {
    return {
      search: '',
      checked: '0',
      incomeType: 0,
      incomeTypes: [
        { text: '全部类型', value: 0 },
        { text: '私聊送礼', value: 22 },
        { text: '心动送礼', value: 63 },
        { text: '普通聊天', value: 52 },
        { text: '微信收益', value: 71 },
        { text: '语音收益', value: 37 },
        { text: '视频收益', value: 55 },
        { text: '邀请充值分成', value: 66 },
        { text: '邀请消费返现', value: 99 },
        { text: '邀请开通会员分成', value: 74 },
      ],
      timeBegin: 0,
      timeEnd: 0,
      showDatePicker: false,
      datePickerMode: 0,
      datePicker: null,
      minDate: null,
      maxDate: null,
      groupInfo: null,
      searchUid: null,
      searchType: 0,
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      incomeList: [],
      totalIncome: 0,
      totalUserChatIncome: 0,
      userInviteRewards: 0,
      totalParentIncome: 0,
      groupChatRewards: 0,
      groupInviteRewards: 0,
      marke: false,
    }
  },
  components: {
    Mask,
  },
  computed: {
    timeBeginDisplay() {
      const date = new Date(this.timeBegin);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    },
    timeEndDisplay() {
      const date = new Date(this.timeEnd);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    }

  },
  mounted() {
    if (this.$route.params.userId) {
      this.search = this.$route.params.userId
      this.searchUid = parseInt(this.search);
    }
    this.reqInfo()
    // this.marke = wxqq()
  },
  methods: {
    /**
     * 根据类型获取对应的收益数据
     * @param {Number} type 流水类型：0收益流水 1充值流水 2会员流水
     * @returns {Object} 对应类型的收益数据对象
     */
    getIncomeByType(type) {
      // 验证输入类型
      if (typeof type !== 'number' || type < 0 || type > 2) {
        console.warn(`无效的流水类型: ${type}`);
        return {};
      }
      
      return this.incomeList.find(item => item.type === type) || {};
    },
     isDiaplay(type){
      if(type.totalOwnerIncome!=0 || type.totalIncome	!=0 || type.totalParentIncome!=0)
    {
      return true
    }
    return false
    },
    colIsDisplay(type){
        if(type.totalOwnerIncome!=0 || type.totalIncome	!=0 || type.totalParentIncome!=0)
    {
      return true
    }
    return false
    },
    /**
     * 检查某一列是否有非零值
     * @param {String} columnName 列名：totalIncome、totalParentIncome、totalOwnerIncome
     * @returns {Boolean} 该列是否有非零值
     */
    isColumnNotEmpty(columnName) {
      // 检查所有行是否在该列上都为0
      const allZero = this.incomeList.every(item => {
        const value = Number(item[columnName]) || 0;
        return value === 0;
      });
      
      // 如果全部为0，则不显示该列
      return !allZero;
    },
       formatNumber(num) {
      // 处理空值或无效值
      if (num === undefined || num === null) {
        return '0';
      }
      
      // 转换为数字
      const number = Number(num);
      if (isNaN(number)) {
        return '0';
      }
      
      // 格式化数字，保留两位小数并添加千分位
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
      /**
     * 计算全部总收益
     * @returns {Number} 所有流水类型的总收益合计
     */
    calculateGrandTotal() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    /**
     * 计算邀请分成总和
     * @returns {Number} 所有类型的邀请分成总和
     */
    calculateTotalParentIncome() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalParentIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    
    /**
     * 计算组长分成总和
     * @returns {Number} 所有类型的组长分成总和
     */
    calculateTotalOwnerIncome() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalOwnerIncome) || 0;
        if(item.totalOwnerIncome==0)
        return sum;
        return sum + value;
      }, 0);
    },
    reqInfo() {
      this.$request.postJson('/api/user/pay_group/info', {})
        .then((res) => {
          if (res.data.code == 0) {
            this.groupInfo = res.data.data;
            if (!this.groupInfo) {
              Toast('暂无推广组信息');
              routerUtil.back()
              return;
            }
            switch (this.groupInfo.period) {
              case 1:
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
              case 2:
                moment
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
              case 3:
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
            }
            this.getList()
            this.getStatistics()
          }
        })
    },
    getList(type) {
      let lastId = ''
      if (type && this.list.length > 0) {
        lastId = this.list[this.list.length - 1].id
      }
      this.$request.postJson('/api/user/pay_group/income_logs', {
        groupId: this.groupInfo.id,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
        lastId: lastId,
        pageSize: 15
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.logs.length == 0) {
            this.loading = false;
            this.refreshing = false
            this.finished = true;
            return
          }
          const uids = [];
          for (let log of res.data.data.logs) {
            uids.push(log.userId);
          }
          this.$request.post('/api/user/info/userInfoByGroup', { userIds: JSON.stringify(uids) })
            .then((res1) => {
              this.loading = false;
              this.refreshing = false
              if (res1.data.code == 0) {
                const userMap = new Map();
                for (let user of res1.data.data.users) {
                  
                    userMap.set(user.userId, user);
                  
                }
                for (let log of res.data.data.logs) {
                  log.userInfo = userMap.get(log.userId);
                }
                this.list.push(...res.data.data.logs)
                this.finished = res.data.data.logs.length < 15
              }
            })
        }
      })
    },
    getStatistics() {
      this.$request.postJson( '/api/user/pay_group/getIncomeTotalList', {
        groupId: this.groupInfo.id,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
      }).then((res) => {
        if (res.data.code == 0) {
          this.incomeList = res.data.data;
           this.incomeList.forEach(item => { 
            if(item.type==1&& item.totalOwnerIncome==0)
          {
            

this.incomeTypes.forEach((item,index)=>{
if(item.value==66)
{
  this.incomeTypes.splice(index, 1);
}
})





            
          }
                if(item.type==2&& item.totalOwnerIncome==0)
          {
            

this.incomeTypes.forEach((item,index)=>{
if(item.value==74)
{
  this.incomeTypes.splice(index, 1);
}
})






            
          }
          });
          // this.totalIncome = res.data.data[0].totalIncome;
          // this.totalUserChatIncome = res.data.data[0].totalUserChatIncome;
          // this.userInviteRewards = res.data.data[0].userInviteRewards;
          // this.totalParentIncome = res.data.data[0].totalParentIncome;
          // this.groupChatRewards = res.data.data[0].groupChatRewards;
          // this.groupInviteRewards = res.data.data[0].groupInviteRewards;

        }
      })
    },
    onClickLeft() {
      routerUtil.back()
    },
    onClickRight() {
    },
    onSearch() {
      if (this.search == "") {
        this.searchUid = null
      } else {
        if (isNaN(Number(this.search, 10))) {
          Toast("请输入用户ID")
          return
        }
        const uid = parseInt(this.search);
        this.searchUid = uid;
      }
      this.searchType = parseInt(this.checked)
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    },
    onIncomeTypeChanged() {
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    },
  onTimeBeginTapped() {
  this.datePickerMode = 1;
  this.datePicker = new Date(this.timeBegin || Date.now());
  
  // 核心：开始时间最早为「当前时间-1个月」，最晚为当前时间
  const oneMonthAgo = moment().subtract(1, 'month').toDate(); // 一个月前
  this.minDate = oneMonthAgo;
  this.maxDate = new Date(); // 当前时间
  
  // UI上只显示最近一个月的日期，超出部分置灰
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
  this.showDatePicker = true;
},

onTimeEndTapped() {
  if (!this.timeBegin) {
    alert('请先选择开始时间');
    return;
  }
  
  this.datePickerMode = 2;
  this.datePicker = new Date(this.timeEnd || this.timeBegin);
  
  // 计算两个上限：开始时间+1个月 和 当天
  const oneMonthLater = moment(this.timeBegin).add(1, 'month').toDate();
  const today = new Date(); // 当天（默认00:00:00，如需包含当天所有时间可改为endOf('day')）
  
  // 结束时间最大可选值为：两者中的较小值（不超过当天，且不超过开始时间+1个月）
  this.minDate = new Date(this.timeBegin);
  this.maxDate = oneMonthLater > today ? today : oneMonthLater;
   this.showDatePicker = true;
  // 禁用超出范围的日期（小于开始时间 或 大于最大限制）
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
 
},

// 确认选择
onDatePickerConfirm(value) {
  switch (this.datePickerMode) {
    case 1:
      // 开始时间已被UI限制在最近一个月内，直接取值
      this.timeBegin = moment(value).startOf('day').valueOf();
      
      // 自动设置结束时间为开始时间+1个月（不超过开始时间+1个月）
      this.timeEnd = moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
      break;
      
    case 2:
      // 结束时间限制在开始时间+1个月内
      this.timeEnd = moment(value).endOf('day').valueOf();
 
      if (this.timeEnd > ( moment(this.timeBegin).add(1, 'month').endOf('day').valueOf())) {
        this.timeEnd =  moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
      }
      break;
  }
  
  this.showDatePicker = false;
  this.datePickerMode = 0;
  this.list = [];
  this.onRefresh();
  this.getStatistics();
},
    onDatePickerCancel() {
      this.datePickerMode = 0;
      this.showDatePicker = false;
    },
    onLoad() {
      this.getList(true)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getList()
    },
    getDisplayTime(time) {
      const date = new Date(time);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const min = date.getMinutes();
      const sec = date.getSeconds();
      return `${date.getFullYear()}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
    }
  },
}
</script>
<style scoped lang="less">
.income-container {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  padding-bottom: 20px;
  color: #333333;
}

/* 导航栏样式 */
:deep(.van-nav-bar) {
  background-color: #FFD700 !important;
  color: #333333 !important;
}

:deep(.van-nav-bar__title) {
  color: #333333 !important;
}

:deep(.van-nav-bar__left) {
  color: #333333 !important;
}

:deep(.van-nav-bar__left-arrow) {
  color: #333333 !important;
}

.content-wrapper {
  padding: 16px;
  color: #999999;
}

/* 搜索栏样式 */
.search-bar {
  margin-bottom: 16px;
  background: transparent;
  
  :deep(.van-search__content) {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  :deep(.van-search__content:focus-within) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  :deep(.van-field__input) {
    color: #333333;
    background: #f5f5f5;
  }
}

.search-btn {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

/* 筛选区域样式 */
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 4px;
}

.id-type-group {
  margin-bottom: 12px;
  
  :deep(.van-radio__label) {
    font-size: 14px;
    color: #999999;
  }
  
  :deep(.van-radio__icon) {
    border-color: #999999;
  }
  
  :deep(.van-radio__icon--checked) {
    color: #333333;
  }
  
  :deep(.van-radio__icon--checked .van-icon) {
    background-color: #FFD700;
    border-color: #FFD700;
  }
}

.income-type-select {
  width: 120px;
  
  :deep(.van-dropdown-menu__bar) {
    box-shadow: none;
    height: 32px;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
  }
  
  :deep(.van-dropdown-menu__title) {
    font-size: 14px;
    color: #333333;
  }
  
  :deep(.van-dropdown-menu__item--active) {
    color: #333333;
  }
  
  :deep(.van-dropdown-menu__content) {
    background-color: #ffffff !important;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  :deep(.van-dropdown-item) {
    background-color: #ffffff;
  }
  
  :deep(.van-dropdown-item__option) {
    color: #333333;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  :deep(.van-dropdown-item__option--active) {
    color: #333333;
    background-color: #FFD700;
  }
  
  :deep(.van-dropdown-item__option:active) {
    background-color: #f0f0f0;
  }
}

/* 日期选择器样式 */
.date-range-selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.date-btn {
  padding: 6px 12px;
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.date-btn:hover {
  background-color: #fff9e6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: #333333;
}

.ltime {
  margin-right: 8px;
}

.date-separator {
  margin: 0 8px;
  color: #888888;
  font-size: 14px;
}

/* 交易列表样式 */
.transaction-list {
  padding-bottom: 240px;
  
  :deep(.van-list__finished-text) {
    color: #666666;
    font-size: 14px;
    margin-top: 20px;
  }
}

.transaction-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.transaction-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  background-color: #fff9e6;
}

.transaction-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 4px;
}

.user-id {
  font-size: 13px;
  color: #666666;
}

.amount {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.transaction-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
}

.transaction-time {
  font-size: 13px;
  color: #666666;
}

.transaction-desc {
  font-size: 14px;
  color: #999999;
  font-weight: 500;
}

/* 统计区域样式 */
.summary-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, #f5f5f5, #ffffff);
  border-radius: 20px 20px 0 0;
  padding: 16px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  max-height: 60vh;
  overflow-y: auto;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #666666;
}

.empty-state span {
  margin-top: 16px;
  font-size: 14px;
}

/* 统计卡片样式 */
.statistics-table-container {
  background-color: #999999;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.statistics-table {
  width: 100%;
  border-collapse: collapse;
}

.statistics-table th {
  background-color: #cccccc;
  color: #333333;
  font-weight: 600;
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid #5a5a5a;
}

.statistics-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #cccccc;
  color: #333333;
}

.statistics-table tr:last-child td {
  border-bottom: none;
}

.income-row td:first-child {
  border-left: 4px solid #666666;
}

.recharge-row td:first-child {
  border-left: 4px solid #777777;
}

.member-row td:first-child {
  border-left: 4px solid #888888;
}

.total-row {
  background-color: #f5f5f5;
  font-weight: 600;
}

.total-row td:first-child {
  border-left: 4px solid #555555;
}

.row-label {
  font-weight: 500;
  color: #333333;
}

.primary-value {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
}

.highlight-value {
  color: #999999;
  font-size: 16px;
  font-weight: 600;
}

.statistics-table tr:hover {
  background-color: #f5f5f5;
}

:deep(.van-datetime-picker__confirm) {
  color: #333333;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .content-wrapper {
    padding: 12px;
  }
  
  .transaction-card {
    padding: 12px;
  }
  
  .statistics-table-container {
    overflow-x: auto;
  }
  
  .statistics-table {
    min-width: 320px;
  }
  
  .statistics-table th,
  .statistics-table td {
    padding: 10px 8px;
    font-size: 14px;
  }
}

/* 滚动条样式 */
.summary-section::-webkit-scrollbar {
  width: 6px;
}

.summary-section::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.summary-section::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.summary-section::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
